import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdvancedNoticeNonCoverageFormComponent } from './advanced-notice-non-coverage-form.component';

const routes: Routes = [
  {
    path: '',
    component: AdvancedNoticeNonCoverageFormComponent,
    children: []
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdvancedNoticeNonCoverageFormRoutingModule { }
